import { useNavigate } from 'react-router-dom';
import { Users, UserPlus, BarChart3, Shield } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import Footer from '../components/Footer';
import { useAuth } from '../App';

const RoleLandingPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  
  // Check if user is admin
  const ADMIN_EMAILS = ['support@contribo.in', 'thefinalshot3@gmail.com', 'intunetesting121@gmail.com', 'mcitpashok@gmail.com', 'anushaammu1103@gmail.com'];
  const isAdmin = user && ADMIN_EMAILS.includes(user.email);

  // Base role options
  const baseRoleOptions = [
    {
      id: 'host',
      title: "I'm a Host or Co-host",
      description: 'Create and manage events, approve contributions',
      icon: Users,
      color: 'from-blue-500 to-blue-600',
      bgColor: 'from-blue-50 to-blue-100',
      borderColor: 'border-blue-300',
      path: '/host-cohost-dashboard'
    },
    {
      id: 'guest',
      title: "I'm a Guest",
      description: 'Join events and contribute to celebrations',
      icon: UserPlus,
      color: 'from-green-500 to-green-600',
      bgColor: 'from-green-50 to-green-100',
      borderColor: 'border-green-300',
      path: '/join-event'
    },
    {
      id: 'dashboard',
      title: 'Event Dashboard',
      description: 'View all your events and activities',
      icon: BarChart3,
      color: 'from-purple-500 to-purple-600',
      bgColor: 'from-purple-50 to-purple-100',
      borderColor: 'border-purple-300',
      path: '/dashboard'
    }
  ];

  // Add Admin tile if user is admin
  const roleOptions = isAdmin ? [
    ...baseRoleOptions,
    {
      id: 'admin',
      title: 'Admin',
      description: 'Manage platform settings and users',
      icon: Shield,
      color: 'from-red-500 to-red-600',
      bgColor: 'from-red-50 to-red-100',
      borderColor: 'border-red-300',
      path: '/admin'
    }
  ] : baseRoleOptions;

  return (
    <div className="min-h-screen bg-gradient-to-br from-contribo-navy from-opacity-5 via-contribo-gold via-opacity-5 to-blue-50">
      {/* Header */}
      <div className="text-center py-6 px-4 bg-gradient-to-r from-contribo-navy to-contribo-gold">
        <h1 className="text-2xl font-bold text-white mb-2">
          Welcome to <span className="text-yellow-300">Contribo</span>
        </h1>
        <p className="text-sm text-white font-semibold">
          RSVP → Blessing → Contribution → Celebration
        </p>
        <p className="text-xs text-white mt-1">
          What would you like to do today?
        </p>
      </div>

      {/* Role Selection Cards - Mobile Optimized for 360px */}
      <div className="max-w-6xl mx-auto px-2 pb-20">
        <div className={`grid ${roleOptions.length === 4 ? 'grid-cols-2' : 'grid-cols-3'} gap-2`}>
          {roleOptions.map((role) => {
            const Icon = role.icon;
            return (
              <Card
                key={role.id}
                className={`cursor-pointer hover:scale-105 transition-all duration-300 border-2 ${role.borderColor} shadow-lg bg-gradient-to-br ${role.bgColor}`}
                onClick={() => navigate(role.path)}
              >
                <CardContent className="p-3 text-center">
                  <div className={`w-12 h-12 mx-auto mb-2 rounded-full bg-gradient-to-br ${role.color} flex items-center justify-center shadow-md`}>
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <h2 className="text-xs font-bold text-gray-900 mb-1 leading-tight">
                    {role.title}
                  </h2>
                  <p className="text-[10px] text-gray-600 leading-tight">
                    {role.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default RoleLandingPage;
